import React, { useMemo, useState } from 'react';
import { Input } from '.';
import { Copy, Flexer } from '../app/dashboard/elements/LayoutElements';
import { PickerItem, PickerMenu, PickerMenuProps } from './PickerMenu';
import { FlexScroller } from './Scrollers';

export interface PickerMenuWithFilterProps<T extends PickerItem> extends PickerMenuProps<T> {
    search?: string;
    filterItem?: (item: T, search: string) => boolean;
};

export const PickerMenuWithFilter = <T extends PickerItem>({ search: searchProp, filterItem, items, ...rest }: PickerMenuWithFilterProps<T>) => {
    const [searchInput, setSearchInput] = useState('');
    const search = searchProp ?? searchInput;

    const filteredItems = useMemo(() => items.filter(x => {
        if (!search) return true;
        if (filterItem) return filterItem(x, search);
        if (x.text) return x.text.toLowerCase().includes(search.toLowerCase());
        if (x.name) return x.name.toLowerCase().includes(search.toLowerCase());
        if (x.label) return x.label.toLowerCase().includes(search.toLowerCase());
        return false;
    }), [items, filterItem, search]);

    return <Flexer grow flex="column" gap=".5">
        {/* {title &&
            <Flexer padding=".5 1" background={Colors.gray50} borderRadius=".5rem .5rem 0 0" borderBottom={`1px solid ${Colors.borderLight}`}>
                <Title flush size="2xs" color={Colors.text} uppercase weight="500">{title}</Title>
            </Flexer>
        } */}
        <Flexer>
            <Input autoFocus compact placeholder="Search..." value={search} onChange={setSearchInput} />
        </Flexer>
        <FlexScroller>
            <PickerMenu {...rest} items={filteredItems} />
            {!!search && filteredItems.length === 0 &&
                <Flexer grow flex center>
                    <Copy flush>Sorry, no matches!</Copy>
                </Flexer>
            }
        </FlexScroller>
    </Flexer>;
};
